export function initSurvey(key) {
  (window.CE_API || (window.CE_API = [])).push(function crazyEggSurvey() {
    CE2.showSurvey(key);
  });
}
